import React from 'react'
import PropTypes from 'prop-types'
import DtoUser from '../../home/dto/DtoUser'
import { connect } from 'react-redux'
import HTML5Backend from 'react-dnd-html5-backend'
import { DragDropContext } from 'react-dnd'
import DtoStation from '../dto/DtoStation'
import DtoType from '../../referential/dto/DtoSiteType'
import StationsTabPanel from './tab/StationsTabPanel'
import SitesAction from '../actions/SitesAction'
import AppStore from '../../store/AppStore'
import HomeAction from '../../home/actions/HomeAction'
import TabsSideBar from '../../components/navbar/TabsSideBar'
import i18n from 'simple-react-i18n'
import ReferentialAction from '../../referential/actions/ReferentialAction'
import DtoCity from '../../referential/dto/DtoCity'
import ThemeDto from '../../administration/dto/ThemeDto'
import ResearchTabPanel from './research/ResearchTabPanel'
import ThemesTabPanel from './tab/ThemesTabPanel'
import DtoFilterType from '../../referential/dto/DtoFilterType'
import SelectionSaveModal from '../../components/modal/selection/SelectionSaveModal'
import UUID from 'uuid'
import { PATH_POINT } from '../../home/constants/HomeConstants'
import ActionComponent from '../../components/ActionComponent'
import ListComponent from '../../components/list/ListComponent'
import AdministrationAction from '../../administration/actions/AdministrationAction'
import SwitchPanel from '../../components/panel/SwitchPanel'
import { getColor } from '../../utils/ThemesUtils'
import SiteTypes from '../../utils/mapUtils/SiteTypes'
import PopupFactory from '../../utils/mapUtils/PopupFactory'
import { getDefaultMapCenter, getDefaultZoom } from '../../utils/ApplicationUtils'
import { getLayer } from '../../utils/mapUtils/LayerUtils'
import SitesPoint from '../../utils/mapUtils/layers/SitesPoint'
import OSM from '../../utils/mapUtils/layers/OSM'
import { createDtoFilter } from '../../utils/ResearchTypesUtils'
import DtoWatershed from '../dto/DtoWatershed'
import DtoRadius from '../dto/DtoRadius'
import ResearchTypes from '../../utils/ResearchTypes'
import { getPlurial, getPlurialWithNumber, substringNumber } from '../../utils/StringUtils'
import DtoLayer from '../../administration/dto/DtoLayer'
import ApplicationConf from '../../conf/ApplicationConf'
import DtoSelectionRow from '../../dashboard/dto/DtoSelectionRow'
import DtoManagementWater from '../../referential/dto/DtoManagementWater'
import OlMap from '../../utils/mapUtils/Map'
import SelectionAction from '../../dashboard/actions/SelectionAction'
import LegendDto from '../../administration/dto/LegendDto'
import { urlsCheckStatus } from '../../utils/actions/CheckStatusAction'
import { capitalize, filter, find, flatten, isEqual, maxBy, minBy, orderBy, pullAllBy, reduce, sumBy, uniq, uniqWith } from 'lodash'
import { checkBetaUser } from '../../utils/UserUtils'
import DtoUserRole from '../../home/dto/DtoUserRole'
import ToastrAction from '../../home/actions/ToastrAction'
import SelectionExportModal from '../../components/modal/selection/SelectionExportModal'
import { MAP_RESEARCH } from '../constants/SitesConstants'

const $ = window.$

const idCityLayerPanel = 'city_layer_panel'
const idWatershedLayerPanel = 'watershed_layer_panel'

class SitesApp extends ActionComponent {
	constructor(props) {
		super(props)
		this.state = {
			height: 250,
			selected: [],
			center: getDefaultMapCenter(props.user),
			zoom: getDefaultZoom(props.user),
			extent: null,
			layersUrl: []
		}
		this.setHeight = this.setHeight.bind(this)
		this.setExtent = this.setExtent.bind(this)
	}

	componentWillMount() {
		if (!this.props.siteTypes.length) {
			AppStore.dispatch(ReferentialAction.fetchSiteTypes())
		}
		if (!this.props.cities.length) {
			AppStore.dispatch(ReferentialAction.fetchCities())
		}
		AppStore.dispatch(SitesAction.fetchSelectedTypes())
		AppStore.dispatch(SitesAction.fetchResearchTypes())
		AppStore.dispatch(HomeAction.setTitle(this.getTitlePage(this.props.selectedSelection)))
		if (this.props.selectedFilters.length) {
			const filterTypeDto = this.props.selectedFilters.map((o) => {
				return createDtoFilter(this.props.filterTypes, o)
			})
			this.initLayers(filterTypeDto, this.props)
		}
		if (this.props.stations && this.props.stations.length > 1) {
			this.setExtent(this.props.stations)
		}
	}

	componentDidMount() {
		this.setHeight()
		$('.tooltipped').tooltip()
	}

	componentWillReceiveProps(nextprops) {
		if (nextprops.stations && nextprops.stations.length && nextprops.stations.length !== this.props.stations.length || (nextprops.selectedTypes && nextprops.selectedTypes.length !== this.props.selectedTypes.length)) {
			AppStore.dispatch(SitesAction.putStations(this.getFinalStation(nextprops.stations)))
			const filterTypeDto = nextprops.selectedFilters.map((o) => {
				return createDtoFilter(this.props.filterTypes, o)
			})
			this.initLayers(filterTypeDto, nextprops)
		}
		if (nextprops.stations.length === this.props.stations.length) {
			this.setExtent(nextprops.stations)
		}
		if (nextprops.selectedFilters.length !== this.props.selectedFilters.length) {
			const filterTypeDto = nextprops.selectedFilters.map((o) => {
				return createDtoFilter(nextprops.filterTypes, o)
			})
			this.initLayers(filterTypeDto, nextprops)
		}
		if (nextprops.selectedSelection) {
			AppStore.dispatch(HomeAction.setTitle(this.getTitlePage(nextprops.selectedSelection)))
		}
		if (nextprops.stations.length === 0 && this.props.stations.length && !nextprops.selectedFilters.length) {
			AppStore.dispatch(SitesAction.updateCitiesLayers([]))
		}

		if (!this.state.layersUrl.length) {
			const layers = flatten(nextprops.selectedThemes.map((o) => o.value.layers)).filter(o => o.type !== 'KML')
			const promiseUrlLegend = urlsCheckStatus(layers)
			promiseUrlLegend.then((url) => {
				const layersUrl = filter(url.map((o) => {
					if (o) {
						const findLayer = (() => {
							const result = filter(layers.map(layer => {
								if (o.includes(layer.layer)) {
									return layer
								}
								return null
							}))
							if (result && result.length) {
								return result[0]
							}
							return null
						})()
						if (findLayer) {
							return {
								id: findLayer.id,
								url: o
							}
						}
						return null
					}
					return null
				}), i => i)
				this.setState({
					layersUrl: layersUrl
				})
			})
		}
	}

	getLogged = () => {
		const token = sessionStorage.getItem('TOKEN')
		return !(!token || !atob(token))
	}

	openModalSave = () => {
		AppStore.dispatch(SelectionAction.openModalSelectionSave())
	}
	getSaveFunction = () => {
		if (checkBetaUser(this.props.userRoles).length && this.props.selections.length === 5) {
			AppStore.dispatch(ToastrAction.warning(i18n.warning.selectionLimit))
		} else {
			const isLogged = this.getLogged()
			if (isLogged) {
				this.openModalSave()
			} else {
				AppStore.dispatch(HomeAction.updateLoginModalState(true))
				AppStore.dispatch(HomeAction.updateLoginModalActions([this.openModalSave]))
			}
		}
	}
	setModalSelectionExport = (selection) => {
		AppStore.dispatch(SelectionAction.openModalSelectionExport(selection))
	}
	getActions = () => {
		const actions = []
		if (this.props.selectedStations && this.props.selectedStations.length) {
			actions.push({
				fn: () => this.getSaveFunction(),
				icon: 'save',
				title: i18n.saveSelection
			})
		}
		if (this.props.selectedSelection && this.props.selectedSelection.id) {
			actions.push({
				fn: () => this.setModalSelectionExport(this.props.selectedSelection),
				icon: 'file_download',
				title: i18n.download
			})
		}
		return actions
	}

	setExtent = (stations) => {
		if (stations && stations.length) {
			const minX = minBy(stations, s => s.xCoordinate).xCoordinate
			const minY = minBy(stations, s => s.yCoordinate).yCoordinate
			const maxX = maxBy(stations, s => s.xCoordinate).xCoordinate
			const maxY = maxBy(stations, s => s.yCoordinate).yCoordinate

			const totalXAverage = sumBy(stations, (station) => {
				return station.xCoordinate
			}) / stations.length
			const totalYAverage = sumBy(stations, (station) => {
				return station.yCoordinate
			}) / stations.length
			const finalMinX = (() => {
				if (minX < 0) {
					return minX + 0.2
				}
				return minX - 0.2
			})()
			const finalMaxX = (() => {
				if (maxX < 0) {
					return maxX + 0.2
				}
				return maxX - 0.2
			})()
			this.setState({
				center: [totalXAverage, totalYAverage],
				zoom: 10.5,
				extent: stations.length > 1 ? [finalMinX, minY, finalMaxX, maxY] : null
			})
		}
	}

	createCityLayer = (city, visibility = false) => {
		return {
			id: city.id,
			name: capitalize(city.name),
			code: city.code,
			url: ApplicationConf.layer.cityLayer(city.code),
			opacity: 1,
			visibility: visibility
		}
	}
	getCity = (code) => {
		return find(this.props.cities, (a) => {
			return a.code == code
		})
	}
	initLayers = (filterTypeDto, props) => {
		// City
		const selectedCities = filter(props.selectedStations, s => s.typeParameter === SiteTypes.CITY.type)
		const filterTypeCity = filter(filterTypeDto, o => {
			if (o.filterTypeId) {
				return o.filterTypeId == '1'
			}
			return o
		})
		const filterCities = filterTypeCity.concat(selectedCities)
		const cityLayers = filterCities.map((o) => {
			const result = (() => {
				const cityResearch = find(filterTypeCity, (a) => {
					return a.value == o.value
				})
				if (cityResearch) {
					const city = this.getCity(cityResearch.value)
					return this.createCityLayer(city, true)
				}
				const city = this.getCity((o.value || o.code))
				return this.createCityLayer(city)
			})()
			return new DtoLayer(result, 'KML')
		})
		AppStore.dispatch(SitesAction.updateCitiesLayers(cityLayers))

		// Management Water (SAGE)
		const filterManagementWater = filter(filterTypeDto, (o) => {
			if (o.filterTypeId) {
				return o.filterTypeId == '98304'
			}
			return o
		})
		const managementWaterLayers = filterManagementWater.map((o) => {
			const managementWater = find(props.managementWaters, (a) => {
				return a.id == o.value
			})
			const result = {
				id: managementWater.id,
				name: managementWater.name,
				code: managementWater.code,
				url: ApplicationConf.layer.managementWaterLayer(managementWater.code),
				opacity: 1,
				visibility: true
			}
			return new DtoLayer(result, 'KML')
		})
		AppStore.dispatch(SitesAction.addManagementWaterLayers(managementWaterLayers))

		// Watershed
		const filterWatershed = filter(filterTypeDto, (o) => {
			if (o.filterTypeId) {
				return o.filterTypeId == '65536'
			}
			return o
		})
		const filterWatershedLayers = filterWatershed.map((o) => {
			const watershed = find(props.watersheds, (a) => {
				return a.id == o.value
			})
			const result = {
				id: watershed.id,
				name: watershed.name,
				code: watershed.code,
				url: ApplicationConf.layer.whatershedLayer(watershed.code),
				opacity: 1,
				visibility: true
			}
			return new DtoLayer(result, 'KML')
		})
		AppStore.dispatch(SitesAction.addWatershedLayers(filterWatershedLayers))
	}

	getTitlePage = (selection) => {
		if (selection && selection.title) {
			return selection.title
		}
		return i18n.stationResearch
	}

	change = (value) => {
		AppStore.dispatch(SitesAction.setVisualisation(value))
	}

	getStationTab() {
		const pointTitle = getPlurialWithNumber(i18n.availablePoint, i18n.availablePoints, this.props.stations.length)
		const hydrologicalAreaTitle = getPlurialWithNumber(i18n.lowerWatershedArea, i18n.lowerWatersheds, this.props.watershedSelected.length)
		const title = this.props.stations.length + ' ' + pointTitle + ' ' + i18n.lowerOn + ' ' + this.props.watershedSelected.length + ' ' + hydrologicalAreaTitle
		return (
			<div className='row no-margin'>
				<div className='col s12 m12 l12 no-padding'>
					<h6> { title }</h6>
					<StationsTabPanel onHover/>
				</div>
			</div>
		)
	}

	changeVisibility = (id) => {
		const selectedThemeUpdate = Object.assign([], this.props.selectedThemes)
		const newSelectedTheme = selectedThemeUpdate.map((o) => {
			const layers = o.value.layers.map((layer) => {
				if (layer.id == id) {
					return Object.assign({}, layer, {
						visibility: !layer.visibility
					})
				}
				return layer
			})
			const result = o
			o.value.layers = layers
			return Object.assign({}, o, result)
		})
		AppStore.dispatch(AdministrationAction.selectedThemes(newSelectedTheme))
	}

	changeOpacity = (id) => {
		const selectedThemeUpdate = Object.assign([], this.props.selectedThemes)
		const newSelectedTheme = selectedThemeUpdate.map((o) => {
			const layers = o.value.layers.map((layer) => {
				if (layer.id == id) {
					return Object.assign({}, layer, {
						opacity: this.refs[id].value
					})
				}
				return layer
			})
			const result = o
			o.value.layers = layers
			return Object.assign({}, o, result)
		})
		AppStore.dispatch(AdministrationAction.selectedThemes(newSelectedTheme))
	}
	addOrRemoveSelectedStations = (layer) => {
		const selectedStations = this.props.selectedStations.map(s => Object.assign({}, s))
		if (layer.visibility) {
			const stationToAdd = filter(this.props.stations, (o) => {
				return o.idWatershed == layer.id
			})
			return [].concat(selectedStations, stationToAdd)
		}
		const stationToRemove = filter(selectedStations, (o) => {
			return o.idWatershed == layer.id
		})
		if (stationToRemove.length) {
			return pullAllBy(selectedStations, stationToRemove, 'id')
		}
		return []
	}

	changeWatershedVisibility = (id) => {
		const newList = Object.assign([], this.props.watershedLayers)
		const findLayer = find(newList, (a) => {
			return a.id == id
		})
		if (findLayer) {
			findLayer.visibility = !findLayer.visibility
		}
		AppStore.dispatch(SitesAction.updateWatershedLayers(newList))
	}

	changeManagementWaterVisibility = (id) => {
		const newList = Object.assign([], this.props.managementWaterLayers)
		const findLayer = find(newList, (a) => {
			return a.id == id
		})
		if (findLayer) {
			findLayer.visibility = !findLayer.visibility
			const stationSelected = this.addOrRemoveSelectedStations(findLayer)
			AppStore.dispatch(SitesAction.setSelectedStations(stationSelected))
		}
		AppStore.dispatch(SitesAction.updateManagementWaterLayers(newList))
	}

	changeCitiesLayersVisibility = (id) => {
		const newList = Object.assign([], this.props.citiesLayers)
		const findLayer = find(newList, (a) => {
			return a.id == id
		})
		if (findLayer) {
			findLayer.visibility = !findLayer.visibility
		}
		AppStore.dispatch(SitesAction.updateCitiesLayers(newList))
	}
	changeVisibilityCityLayer = (visibility = false) => {
		return this.props.citiesLayers.map(o => {
			return Object.assign({}, o, {
				visibility: visibility
			})
		})
	}
	changeVisibilityWatershedsLayer = (visibility = false) => {
		return this.props.watershedLayers.map(o => {
			return Object.assign({}, o, {
				visibility: visibility
			})
		})
	}
	resetAllLayers = (id, isCheck) => {
		switch (id) {
			case idCityLayerPanel:
				const selectedCityLayer = (() => {
					if (isCheck) {
						return this.changeVisibilityCityLayer(true)
					}
					return this.changeVisibilityCityLayer()
				})()
				AppStore.dispatch(SitesAction.updateCitiesLayers(selectedCityLayer))
				break
			case idWatershedLayerPanel:
				const watershedLayers = (() => {
					if (isCheck) {
						return this.changeVisibilityWatershedsLayer(true)
					}
					return this.changeVisibilityWatershedsLayer()
				})()
				AppStore.dispatch(SitesAction.updateWatershedLayers(watershedLayers))
				break
			default:
				break
		}
	}

	getLayersTab() {
		const entities = []
		const layersSize = []

		orderBy(filter(this.props.selectedThemes, ['value.disable', false]), ['value.id'], ['asc']).forEach((theme) => {
			const color = getColor(this.props.themes, theme.value, 1)
			const size = theme.value.layers.length
			if (size) {
				const layers = theme.value.layers.map((layer, i) => {
					const opacityId = UUID.v4()
					const url = (() => {
						const result = find(this.state.layersUrl, (o) => {
							return o.id == layer.id
						})
						if (result) {
							return result.url
						}
						return null
					})()
					const img = url ? (<img src={ url } className='responsive-img theme-icon center-align'/>) : null
					const legendDto = new LegendDto({
						id: theme.value.id + '_' + i,
						content: img
					})
					layersSize.push(layer)
					const pictureDiv = (() => {
						if (!url) {
							return null
						}
						return (
							<div className='col s1 no-padding center clickable'
								 onClick={ () => AppStore.dispatch(AdministrationAction.addLegend(legendDto)) }>
								<i className='material-icons help-icon'>info_outline</i>
							</div>
						)
					})()
					const classNameTitle = pictureDiv ? 's9' : 's10'
					return (
						<div className='help-panel'>
							<SwitchPanel key={ i } onToggleCheck={ () => this.changeVisibility(layer.id) }
										 checked={ layer.visibility }>
								<div className='row no-margin valign-wrapper'>
									<div className={ 'col padding-left-20' + classNameTitle }>
										<h6>{ layer.name }</h6>
									</div>
									<div className='col s2 range-field no-padding'>
										<input type='range' ref={ layer.id } id={ opacityId } min={ 0 } max={ 1 }
											   step={ 0.1 }
											   value={ layer.opacity } onChange={ () => this.changeOpacity(layer.id) }/>
									</div>
									{ pictureDiv }
								</div>
							</SwitchPanel>
						</div>
					)
				})
				const result = {
					title: `${ theme.label } ( ${ size } )`,
					component: layers,
					picture: theme.value.pic,
					color: color
				}
				entities.push(result)
			}
		})
		if (this.props.watershedLayers.length) {
			const watershedLayers = orderBy(this.props.watershedLayers, ['code'], ['asc']).map((layer) => {
				return (
					<SwitchPanel key={ UUID.v4() } onToggleCheck={ () => this.changeWatershedVisibility(layer.id) }
								 checked={ layer.visibility }>
						<div className='row no-margin'>
							<div className='col s12 no-padding'>
								<h6>{ layer.code } : { layer.name }</h6>
							</div>
						</div>
					</SwitchPanel>
				)
			})
			const title = getPlurial(i18n.watershedArea, i18n.watersheds, this.props.watershedLayers) + ' (' + this.props.watershedLayers.length + ')'
			const isToogle = this.props.watershedLayers.filter(o => o.visibility).length === this.props.watershedLayers.length
			const result = {
				title: title,
				component: watershedLayers,
				isToogle,
				id: idWatershedLayerPanel,
				icon: 'texture'
			}
			entities.unshift(result)
		}
		if (this.props.managementWaterLayers.length) {
			const managementWaterLayers = orderBy(this.props.managementWaterLayers, ['code'], ['asc']).map((layer) => {
				return (
					<SwitchPanel key={ UUID.v4() }
								 onToggleCheck={ () => this.changeManagementWaterVisibility(layer.id) }
								 checked={ layer.visibility }>
						<div className='row no-margin'>
							<div className='col s12 no-padding'>
								<h6>{ layer.code } : { layer.name }</h6>
							</div>
						</div>
					</SwitchPanel>
				)
			})
			const result = {
				title: `SAGE ( ${ this.props.managementWaterLayers.length } )`,
				component: managementWaterLayers,
				icon: 'texture'
			}
			entities.unshift(result)
		}
		if (this.props.citiesLayers.length) {
			const citiesLayers = orderBy(this.props.citiesLayers, ['code'], ['asc']).map((layer) => {
				return (
					<SwitchPanel onToggleCheck={ () => this.changeCitiesLayersVisibility(layer.id) }
								 checked={ layer.visibility }>
						<div className='row no-margin'>
							<div className='col s12 no-padding'>
								<h6>{ layer.code } : { layer.name }</h6>
							</div>
						</div>
					</SwitchPanel>
				)
			})
			const sizeCityLayer = this.props.citiesLayers.length
			const title = sizeCityLayer > 1 ? i18n.administrativeLimits : i18n.administrativeLimit
			const isToogle = this.props.citiesLayers.filter(o => o.visibility).length === this.props.citiesLayers.length
			const result = {
				title: `${ title } (${ sizeCityLayer })`,
				component: citiesLayers,
				isToogle,
				id: idCityLayerPanel,
				icon: 'location_city'
			}
			entities.unshift(result)
		}
		return (
			<div className='row'>
				<div className='col s12 m12 l12 no-padding'>
					{ this.getTitle(i18n.layerAvailable, i18n.layersAvailable, layersSize.length) }
					{ entities ? (
						<ListComponent tables={ entities } generalFunction={ this.resetAllLayers }/>
					) : (
						<div>{ i18n.noLayerAvailable }</div>
					) }
				</div>
			</div>
		)
	}

	getCityLegend = (defaultStyle) => {
		if (this.props.citiesLayers.length) {
			const style = Object.assign({}, defaultStyle, {
				backgroundColor: '#ff0000'
			})
			return (
				<div key={ UUID.v4() } className='row no-margin'>
					<div className='col s4 theme-icon-column valign-wrapper icon-img'>
						<hr style={ style }/>
					</div>
					<div className='col s8'>
						<span className='title'> { i18n.point.city }</span>
					</div>
				</div>
			)
		}
		return null
	}
	getWatershedLegend = (defaultStyle) => {
		if (this.props.watershedLayers.length) {
			const style = Object.assign({}, defaultStyle, {
				backgroundColor: '#0000ff'
			})
			return (
				<div key={ UUID.v4() } className='row no-margin'>
					<div className='col s4 theme-icon-column valign-wrapper icon-img'>
						<hr style={ style }/>
					</div>
					<div className='col s8'>
						<span className='title'> { i18n.point.watershed }</span>
					</div>
				</div>
			)
		}
		return null
	}

	getManagementWaterLegend = (defaultStyle) => {
		if (this.props.managementWaterLayers.length) {
			const style = Object.assign({}, defaultStyle, {
				backgroundColor: 'black'
			})
			return (
				<div key={ UUID.v4() } className='row no-margin'>
					<div className='col s4 theme-icon-column valign-wrapper icon-img'>
						<hr style={ style }/>
					</div>
					<div className='col s8'>
						<span className='title'> { i18n.managementWater }</span>
					</div>
				</div>
			)
		}
		return null
	}

	getDefaultLegends = () => {
		const style = {
			height: '5px',
			width: '100px'
		}
		const layers = []
		const city = this.getCityLegend(style)
		const watershed = this.getWatershedLegend(style)
		const managementWater = this.getManagementWaterLegend(style)
		if (city) {
			layers.push(city)
		}
		if (watershed) {
			layers.push(watershed)
		}
		if (managementWater) {
			layers.push(managementWater)
		}
		if (layers.length) {
			return {
				title: i18n.defaultLegend + '(' + layers.length + ')',
				component: layers,
				icon: 'location_city'
			}
		}
		return null
	}

	getTitle = (title, plurialTitle, number) => {
		return (
			<h6>{ number } { getPlurialWithNumber(title, plurialTitle, number) }</h6>
		)
	}

	getSimpleTitle = (title, number) => {
		return (
			<h6>{ number } { title }</h6>
		)
	}

	setTitle = (title) => {
		if (this.props.stations.length) {
			return title + ' (' + this.props.selectedStations.length + '/' + this.props.stations.length + ')'
		}
		return title
	}

	getTabsSideBar() {
		const content = [
			{
				icon: 'list',
				title: this.setTitle(i18n.selectData),
				content: this.getStationTab(),
				defaultActive: true
			},
			{
				icon: 'filter_list',
				title: this.setTitle(i18n.filterDataByTheme),
				content: (<ThemesTabPanel/>),
				defaultActive: false
			},
			{
				icon: 'layers',
				title: this.setTitle(i18n.displayLayers),
				content: this.getLayersTab(),
				defaultActive: false
			}
		]
		return (<TabsSideBar tabs={ content } isOpen={ !!this.props.stations.length }/>)
	}


	setHeight() {
		this.setState({ height: document.body.clientHeight - $('#map').offset().top })
	}

	onOpenTopBar() {
		const top = $('.ribbon').offset().top
		const height = document.body.clientHeight - top
		$('.side-component').css({ height: `${ height }px`, top: `${ top }px` })
	}

	openModal = (id) => {
		''
		$(`#${ id }`).modal('open')
	}

	getRadius = (coord, radius) => {
		const joinParameter = coord.concat(radius.toFixed(2))
		const rad = parseFloat(joinParameter[2])
		if (rad > 20) {
			AppStore.dispatch(ToastrAction.error(i18n.error.radiusLimited20km))
			return
		}
		const radiusDto = new DtoRadius(joinParameter[0], joinParameter[1], rad)
		const filterTypeRadius = {
			label: 'x: ' + substringNumber(radiusDto.longi) + ' y: ' + substringNumber(radiusDto.lati) + ' ' + i18n.radius + ': ' + parseFloat(radiusDto.radius),
			value: radiusDto,
			type: ResearchTypes.RADIUS
		}
		const tmp = this.props.selectedFilters.slice()
		tmp.push(filterTypeRadius)
		const selectedFilters = uniqWith(tmp, isEqual)
		AppStore.dispatch(AdministrationAction.selectedFilters(selectedFilters))
		SitesAction.launchResearch(selectedFilters, this.props.selectedThemes, this.props.filterTypes)
	}

	getKmlCities = () => {
		return this.props.citiesLayers.filter(a => a.visibility).map(layer => {
			return getLayer(layer, PopupFactory.popupKmlCity, {
				title: i18n.town
			})
		})
	}
	getKmlDepartments = () => {
		return this.props.citiesLayers.filter(a => a.visibility).map(layer => {
			return getLayer(layer, PopupFactory.popupKmlCity, {
				title: i18n.town
			})
		})
	}

	getWaterShedKml = () => {
		return this.props.watershedLayers.filter(a => a.visibility).map(layer => {
			return getLayer(layer, PopupFactory.popupKmlWaterSheed, {
				title: i18n.watershedArea
			})
		})
	}
	getManagementWaterKml = () => {
		return this.props.managementWaterLayers.filter(a => a.visibility).map(layer => {
			return getLayer(layer, PopupFactory.popupKmlManagementWater, {
				title: 'SAGE'
			})
		})
	}

	getFinalStation = (propsStation) => {
		const piezoQualitoStations = filter(propsStation, (o) => {
			return o.isPiezometer == '1' && o.isQualitometer == '1'
		})
		const typePiezometer = SiteTypes.getTypeByParameter(SiteTypes.PIEZOMETER.type, this.props.siteTypes)
		return piezoQualitoStations.map((o) => {
			return Object.assign({}, o, {
				typeId: typePiezometer.id,
				typeParameter: typePiezometer.parameter
			})
		})
	}

	getMapConf() {
		return {
			size: this.state.height,
			center: this.state.center,
			zoom: this.state.zoom,
			extent: this.state.extent
		}
	}

	getLayers() {
		const layers = uniqWith(flatten(this.props.selectedThemes.map(theme =>
			theme.value.layers.filter(a => a.visibility).map(layer => layer)
		)), (a, b) => a.id === b.id).map(layer => {
			return getLayer(layer)
		})
		const siteTypes = uniq(flatten(this.props.selectedThemes.map(theme =>
			theme.value.siteTypes.map(t => t.type)
		)))
		const kmlCities = this.getKmlCities()
		const kmlWatershed = this.getWaterShedKml()
		const kmlManagementWater = this.getManagementWaterKml()

		if (this.props.selectedStations.length > 0) {
			const filterByTypes = reduce(this.props.selectedStations, (acc, v) => {
				const type = find(siteTypes, t => t === v.typeParameter)
				if (type) {
					(acc[v.typeId] || (acc[v.typeId] = [])).push(v)
				}
				return acc
			}, {})
			const points = Object.keys(filterByTypes).map((o) => {
				return SitesPoint({
					site: filterByTypes[o],
					type: SiteTypes.getType(o, this.props.siteTypes),
					link: PATH_POINT
				})
			})

			return [].concat([OSM()], layers, kmlWatershed, kmlManagementWater, kmlCities, points)
		}
		return [].concat([OSM()], layers, kmlWatershed, kmlManagementWater, kmlCities)
	}

	render() {
		return (
			<div className='row no-margin' ref='refWidth'>
				<SelectionSaveModal/>
				<SelectionExportModal/>
				<ResearchTabPanel actions={ this.getActions() } isLogged={ this.props.isLogged } page={MAP_RESEARCH}/>
				{ this.getTabsSideBar() }
				<div className='col s12 no-padding'>
					<div className='row no-margin' id='mapResearch'>
						<OlMap key='radiusResearchPanel' mapConf={ this.getMapConf() } layers={ this.getLayers() }
							   radius={ this.getRadius }/>
					</div>
				</div>
			</div>
		)
	}

	componentWillUnmount() {
		AppStore.dispatch(SelectionAction.resetSelectedSelection())
		AppStore.dispatch(SitesAction.reset())
		AppStore.dispatch(AdministrationAction.resetSelectedFilters())
		AppStore.dispatch(AdministrationAction.resetEntry())
		AppStore.dispatch(AdministrationAction.resetSelectedThemes())
	}
}

SitesApp.propTypes = {
	params: PropTypes.shape({
		isOpen: PropTypes.string
	}),
	user: PropTypes.objectOf(DtoUser),
	isLogged: PropTypes.bool,
	userRoles: PropTypes.arrayOf(PropTypes.instanceOf(DtoUserRole)),
	login: PropTypes.string,
	stations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation)),
	cities: PropTypes.arrayOf(PropTypes.instanceOf(DtoCity)),
	watersheds: PropTypes.arrayOf(PropTypes.instanceOf(DtoWatershed)),
	managementWaters: PropTypes.arrayOf(PropTypes.instanceOf(DtoManagementWater)),
	siteTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoType)),
	selectedValue: PropTypes.string,
	oldValue: PropTypes.string,
	radius: PropTypes.string,
	selectedFilters: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.object
	})),
	selectedThemes: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.instanceOf(ThemeDto)
	})),
	filterTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoFilterType)),
	themes: PropTypes.arrayOf(PropTypes.instanceOf(ThemeDto)),
	watershedSelected: PropTypes.arrayOf(PropTypes.instanceOf(DtoWatershed)),
	watershedLayers: PropTypes.arrayOf(PropTypes.instanceOf(DtoLayer)),
	managementWaterLayers: PropTypes.arrayOf(PropTypes.instanceOf(DtoLayer)),
	citiesLayers: PropTypes.arrayOf(PropTypes.instanceOf(DtoLayer)),
	selectedSelection: PropTypes.instanceOf(DtoSelectionRow),
	selections: PropTypes.arrayOf(PropTypes.instanceOf(DtoSelectionRow)),
	selectedStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation))
}

SitesApp.defaultProps = {
	login: '',
	isLogged: false
}

const mapStateToProps = store => {
	return {
		user: store.HomeReducer.user,
		userRoles: store.HomeReducer.userRoles,
		stations: store.SitesReducer.stations,
		selectedValue: store.SitesReducer.selectedValue,
		oldValue: store.SitesReducer.oldValue,
		radius: store.SitesReducer.radius,
		siteTypes: store.ReferentialReducer.siteTypes,
		cities: store.ReferentialReducer.cities,
		watersheds: store.ReferentialReducer.watersheds,
		managementWaters: store.ReferentialReducer.managementWaters,
		selectedFilters: store.AdministrationReducer.selectedFilters,
		filterTypes: store.ReferentialReducer.filterTypes,
		selectedThemes: store.AdministrationReducer.selectedThemes,
		themes: store.AdministrationReducer.themes,
		watershedSelected: store.SitesReducer.watershedSelected,
		watershedLayers: store.SitesReducer.watershedLayers,
		managementWaterLayers: store.SitesReducer.managementWaterLayers,
		citiesLayers: store.SitesReducer.citiesLayers,
		selectedSelection: store.SelectionReducer.selectedSelection,
		selections: store.SelectionReducer.selections,
		selectedStations: store.SitesReducer.selectedStations
	}
}

const dragContext = DragDropContext(HTML5Backend)(SitesApp)

export default connect(mapStateToProps)(dragContext)



// WEBPACK FOOTER //
// ./src/sites/components/SitesApp.js